<template>
    <c-search-form :input-search-items="searchItems"
                   :rows-per-page-items="[10,20,50]"
                   :form-name="formName"
                   model="searchForm" :fields="fields"
                   key-property="logId"
                   search-url="/userlog/search"
                   :accept-create="false"
                   :accept-delete="false"
                   >
    </c-search-form>
</template>

<script>
    import axios from "axios";
    import CSearchForm from "../../components/form/ManageForm";
    import moment from "moment";

    export default {
        name: 'log-management',
        components: {CSearchForm},
        data: () => {
            return {
                formName: "lang.userlog.title",
                searchItems: [
                    {
                        type: "text",
                        name: "userName",
                        label: "lang.userlog.userName",
                        placeHolder: "",
                        focus: true
                    },
                    {
                        type: "text",
                        name: "feature",
                        label: "lang.userlog.feature",
                        placeHolder: ""
                    },
                    {
                        type: "datepicker",
                        name: "createFrom",
                        label: "lang.userlog.createFrom",
                        value:moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                        placeHolder: ""
                    },
                    {
                        type: "datepicker",
                        name: "createTo",
                        label: "lang.userlog.createTo",
                        placeHolder: ""
                    }
                ],
                fields: [
                    {
                        value: "index",
                        text: "lang.common.index",
                        width: "5%",
                        sortable: false,
                        headerStyle: "text-align:center"
                    },
                    {
                        value: 'userName',
                        text: 'lang.category.subjectCode',
                        width: "20%",
                        sortable: false,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'feature',
                        text: 'lang.userlog.feature',
                        width: "25%",
                        sortable: false,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'description',
                        text: 'lang.userlog.description',
                        width: "25%",
                        sortable: false,
                        headerStyle: "text-align:center",
                        
                    },
                    {
                        value: 'createdAt',
                        text: 'lang.common.create_at',
                        width: "25%",
                        sortable: false,
                        dateFormat: 'dd/MM/yyyy hh:mm',
                        headerStyle: "text-align:center",
                    }
                ]
            }
        },
    }
</script>
